module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramda/src/internal/_isString.js
 ** module id = 308
 ** module chunks = 0
 **/